import { useQuery } from '@apollo/client'
import { WizardStep } from '@factorialco/deprecated-design-system'
import { CheckFeatureFlagsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { A3InnuvaWizardData } from 'modules/payroll_integrations_a3innuva/lib/types'

import { absencesStep } from './AbsencesStep'
import { compensationStep } from './CompensationStep'
import { loginStep } from './LoginStep'
import { rolesStep } from './RolesStep'
import { workplaceStep } from './WorkplaceStep'
import { agreementStep } from './agreementStep'
import { companyStep } from './companyStep'
import { costCenterStep } from './costCenterStep'
import { educationLevelStep } from './educationLevelStep'

export const useA3InnuvaSteps = () => {
  const session = useCurrentSession()
  const { data: featuresData } = useQuery(CheckFeatureFlagsDocument, {
    variables: {
      companyId: session.company.id,
      names: ['dev_compensations', 'dev_a3innuva_sync_payroll_compensations'],
    },
  })

  const compensationsEnabled =
    featuresData?.features?.featuresConnection?.nodes[0]?.enabled ?? false
  const syncPayrollCompensationsEnabled =
    featuresData?.features?.featuresConnection?.nodes[1]?.enabled ?? false

  let steps: (() => WizardStep<A3InnuvaWizardData>)[] = []
  if (compensationsEnabled && syncPayrollCompensationsEnabled) {
    steps = [
      loginStep,
      companyStep,
      workplaceStep,
      rolesStep,
      compensationStep,
      absencesStep,
      costCenterStep,
      educationLevelStep,
      agreementStep,
    ]
  } else {
    steps = [
      loginStep,
      companyStep,
      workplaceStep,
      rolesStep,
      absencesStep,
      costCenterStep,
      educationLevelStep,
      agreementStep,
    ]
  }

  return steps
}
